import type { AnalyticalVariableWithChangeStatus } from '@verantos-dev/app-state-cohort-definition';
import type { AnalyticalVariable, AnalyticalVariableCriterion } from '@verantos-dev/types-cohorts';

/**
 * UI-side type for AV with change tracking fields.
 * Canonical definition lives in the store — re-exported here for adapter consumers.
 */
export type AVUIModel = AnalyticalVariableWithChangeStatus;

export type AVCriterionUIModel = AnalyticalVariableCriterion;

/** Backend → UI (passthrough, preserves changeStatus/changedBy) */
export const avToUI = (server: AVUIModel): AVUIModel => server;

/** UI → Backend (strips change tracking fields) */
export const avToServer = (ui: AVUIModel): AnalyticalVariable => {
  const copy = { ...ui };
  delete copy.changeStatus;
  delete copy.changedBy;
  return copy as AnalyticalVariable;
};

/** Backend criterion → UI criterion */
export const avCriterionToUI = (server: AnalyticalVariableCriterion): AVCriterionUIModel => server;

/** UI criterion → Backend criterion */
export const avCriterionToServer = (ui: AVCriterionUIModel): AnalyticalVariableCriterion => ui;
